import { render, staticRenderFns } from "./group-star.vue?vue&type=template&id=322a3d2a&"
import script from "./group-star.js?vue&type=script&lang=js&"
export * from "./group-star.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports